export function BrandMark({ className = "" }: { className?: string }) {
  return (
    <span className={`brand-mark ${className}`.trim()} aria-hidden="true">
      <span className="brand-lobe brand-lobe-nw" />
      <span className="brand-lobe brand-lobe-ne" />
      <span className="brand-lobe brand-lobe-sw" />
      <span className="brand-lobe brand-lobe-se" />
      <span className="brand-core" />
    </span>
  );
}
